'use client'

import type { ReactNode } from 'react'
import { Modal } from '../modal.tsx'

export const FieldModalMain = ({ children }: { children: ReactNode }) => {
  return (
    <Modal.Dialog className="p-0 w-full h-full">
      <div className="w-full h-full flex flex-col divide-y divide-subtle">
        {children}
      </div>
    </Modal.Dialog>
  )
}
